import React, {Component} from 'react';
import { get, post } from '../utils/request';
import Dialog from '../components/dialog';
import { regExpression, isPhone, constant, scrollToAnchor } from '../utils/util';
import resolve from 'resolve';
import { updateTimelineShareData } from 'weixin-js-sdk';


// Common Textarea
class CommonTextarea extends Component {
  static defaultProps = {
    title: '',
    name: '',
    value: '',
    holder: '',
    checkErr: false,
    maxLength: 2000
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = (this.props.checkErr && !!!this.props.value) || (this.props.value.length > this.props.maxLength);
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-textarea ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">{ this.props.title }</label>
        <textarea
          className={classShowName}
          name={this.props.name}
          value={this.props.value}
          onChange={this.handleChange}
          placeholder={this.props.holder}
        />
        { showErr && <span className="err-tips narrow-err-tips">{this.props.holder }</span> }
      </div>
    )
  }
}

// Common Input
class CommonInput extends Component {
  static defaultProps = {
    name: '',
    title: '',
    holder: '',
    value: '',
    checkErr: false,
    errorMsg: '',
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.value;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">{ this.props.title }</label>
        <input
          type="text"
          className={classShowName}
          name={this.props.name}
          value={this.props.value}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">{this.props.errorMsg}</span> }
      </div>
    )
  }
}

// 项目名称
class ProjectName extends Component  {
  static defaultProps = {
    name: '',
    recive_title: ''
  }
  handleChange = (e) => {
    const [key, value] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    const showErr = this.props.checkErr && !!!this.props.name;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">{ this.props.recive_title || '项目名称：'}</label>
        <input
          type="text"
          className={classShowName}
          name="name"
          value={this.props.name}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写项目名称</span> }
      </div>
    )
  }
}

// 职位
class Position extends Component {
  static defaultProps = {
    position: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.position;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">职位：</label>
        <input
          type="text"
          className={classShowName}
          name="position"
          value={this.props.position}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写职位</span> }
      </div>
    )
  }
}

// 项目介绍
class IntroProject extends Component {
  static defaultProps = {
    intro: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.intro;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-textarea ${err}`;
    return (
      <div className="info-item">
        {
          this.props.classType === '卓见沙龙' ?
          <label className="s-label">项目介绍:</label> :
          <label className="s-label">项目介绍{ !isPhone() && <br/> }及核心竞争力:</label>
        }
        <textarea
          className={classShowName}
          name="intro"
          value={this.props.intro}
          onChange={this.handleChange}
          placeholder="不填写完整无法进入电话沟通筛选环节"
        />
        { showErr && <span className="err-tips">请填写项目介绍</span> }
      </div>
    )
  }
}

// 项目进展
class IntroOtherProject extends Component {
  static defaultProps = {
    intro: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.intro;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-textarea ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">项目进展：</label>
        <textarea
          className={classShowName}
          name="intro"
          value={this.props.intro}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写项目进展</span> }
      </div>
    )
  }
}

// 项目一句话简介
class Brief extends Component {
  static defaultProps = {
    brief: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.brief;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-textarea ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">项目一句话介绍:</label>
        <textarea
          className={classShowName}
          name="brief"
          value={this.props.brief}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写一句话介绍</span> }
      </div>
    )
  }
}

// 融资轮次
class FinancingRound extends Component {
  static defaultProps = {
    financing_stage: '',
    title: '轮次:',
    name: 'financing_stage',
    type: 'all',
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    const showErr = this.props.checkErr && !!!this.props.financing_stage;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-select ${err}`;
    const _map = {
      'smallest': regExpression().financingRoundSmallest,
      'small': regExpression().financingRoundSmall,
      'all': regExpression().financingRoundAll,
      'type4': regExpression().financingRoundType4
    }
    const _round_list = _map[this.props.type] || []
  
    return (
      <div className="info-item">
        <label className="s-label">{ this.props.title }</label>
        <select
          className={classShowName}
          name={this.props.name}
          value={this.props.financing_stage}
          onChange={this.handleChange}>
          <option value="">请选择</option>
            {
              _round_list.map(val => {
                return <option key={val.toString()} value={val}>{val}</option>
              })
            }
        </select>
        { showErr && <span className="err-tips">请选择轮次</span> }
      </div>
    )
  }
}

// 项目方向
class Kryptis extends Component {
  static defaultProps = {
    kryptis: ''
  }
  constructor(props) {
    super(props);
    this.state = {...props};
  }
  handleChange = (event) => {
    this.setState({
      kryptis: event.target.value
    })
    this.props.returnData({kryptis: event.target.value});
  }
  render() {
    return (
      <select className={this.props.classReName} value={this.state.kryptis} onChange={this.handleChange}>
        <option value="">请选择</option>
        {
          this.props.kryptisData && this.props.kryptisData.map((val) => {
            return <option key={val.toString()} value={val}>{val}</option>
          })
        }
      </select>
    )
  }
}

// 项目领域
class Laukas extends Component {
  static defaultProps = {
    laukas: '',
    kryptis: ''
  }
  handleChange = (event) => {
    this.setState({
      laukas: event.target.value
    })
    this.props.returnData({laukas: event.target.value});
  }
  render() {
    this.state = {...this.props};
    const classShowName = `${this.props.classReName} right`;
    return (
      <select className={classShowName} value={this.state.laukas} onChange={this.handleChange}>
        <option value="">请选择</option>
        { this.props.kryptis &&
          this.props.laukasData[this.props.kryptis] && this.props.laukasData[this.props.kryptis].map((val) => {
            return <option key={val.toString()} value={val}>{val}</option>
          })
        }
      </select>
    )
  }
}

// 项目方向领域组件
class KryptisLaukas extends Component {
  static defaultProps = {
    kryptis: '',
    laukas: '',
    recive_title: '',
    industryData: {
      first: [],
      second: []
    }
  }
  constructor(props) {
    super(props);
    this.state = {...props};
  }
  handleData = (resJson) => {
    // 设置kryptis值
    resJson.hasOwnProperty("kryptis") && this.setState({
      kryptis: resJson['kryptis'],
      laukas: ''
    })

    // 设置laukas值
    resJson.hasOwnProperty("laukas") && this.setState({
      laukas: resJson['laukas'],
    })

    // 回传值
    this.props.onValueChange({
      kryptis: resJson.hasOwnProperty("kryptis") ? resJson['kryptis'] : this.state.kryptis,
      laukas: resJson['laukas'] ? resJson['laukas'] : ''
    })
  }
  showErr = (kryptis, laukas) => {
    if (this.props.checkErr && (!!!kryptis || !!!laukas)) {
      return <span className="err-tips">请选择方向领域</span>
    }
    return null;
  }
  componentDidMount () {
    get('/fancube/project/industry')
    .then(res => {
      if (res.code === 200) {
        this.setState({
          industryData: res.data
        });
      }
    })
  }
  render() {
    const showErrKryptis = this.props.checkErr && !!!this.state.kryptis;
    const showErrLaukas = this.props.checkErr && !!!this.state.laukas;
    const errk = showErrKryptis ? 'err-s' : '';
    const errL = showErrLaukas ? 'err-s' : '';
    const classShowKrName = `s-select ${errk}`;
    const classShowLaName = `s-select ${errL}`;
    return (
      <div className="info-item">
        <label className="s-label">{ this.props.recive_title || '项目方向/领域：' }</label>
        <Kryptis kryptis={this.state.kryptis} kryptisData={this.state.industryData.first} returnData={this.handleData} classReName={classShowKrName} />
        <Laukas  laukas={this.state.laukas} kryptis={this.state.kryptis} laukasData={this.state.industryData.second} returnData={this.handleData} classReName={classShowLaName}/>
        {this.showErr(this.state.kryptis, this.state.laukas)}
      </div>
    )
  }
}

// 工作状态
class WorkStatus extends Component {
  static defaultProps = {
    status: '创业中'
  }
  handleChange = (e) => {
    const [key, value] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    return (
      <div className="info-item">
        <label className="s-label">工作状态：</label>
        {isPhone() && <br/>}
        <label className="s-radio">
          <input type="radio" value="创业中" checked={this.props.status === '创业中' ? true: false} onChange={this.handleChange}  name="status" />
          <span className="span-radio">创业中</span>
        </label>
        <label className="s-radio">
          <input type="radio" value="准备创业" checked={this.props.status === '准备创业' ? true: false} onChange={this.handleChange}  name="status" />
          <span className="span-radio">准备创业</span>
        </label>
        <label className="s-radio">
          <input type="radio" value="在职" checked={this.props.status === '在职' ? true: false} onChange={this.handleChange}  name="status" />
          <span className="span-radio">在职</span>
        </label>
      </div>
    )
  }
}

// 公司名称
class Company extends Component {
  static defaultProps = {
    company_name: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.company_name;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">公司名称：</label>
        <input
          type="text"
          className={classShowName}
          name="company_name"
          value={this.props.company_name}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写公司名称</span> }
      </div>
    )
  }
}

// 公司结构
class CompanyStructure extends Component {
  static defaultProps = {
    company_structure: '',
    title: '公司架构:',
    name: 'company_structure',
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    const showErr = this.props.checkErr && !!!this.props.company_structure;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-select ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">{ this.props.title }</label>
        <select className={classShowName} name={this.props.name} value={this.props.company_structure} onChange={this.handleChange}>
          <option value="">请选择</option>
          {
            constant().companyStructure.map(val => {
              return <option key={val.toString()} value={val}>{val}</option>
            })
          }
        </select>
        { showErr && <span className="err-tips">请选择公司架构</span> }
      </div>
    )
  }
}

// 项目标签
class ProjectTag extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tagNameList: [],
      showMask: false,
      keyword: ''
    }
  }
  static defaultProps = {
    tags: []
  }
  handleChange = (e) => {
    if (e.target.name == 'tag-keyword') {
      this.getTagList(e.target.value)
    }
  }
  getTagList = (keyword) => {
    this.setState({
      tagNameList: [],
      showMask: true,
      keyword: keyword
    })
    get('/fancube/tag/check/',{
      params:{'keyword': keyword}
    })
    .then( res => {
      this.setState({
        tagNameList: res.data
      })

      if (res.data.length == 0) {
        this.setState({
          showMask: false
        })
      }
    })
  }
  render() {
    const showErr = this.props.checkErr && [].concat(this.props.tags).length == 0;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`
    return (
      <div className="info-item">
        <label className="s-label">公司行业/领域：</label>
        <div className="multiple-select-wrap">
          <div className="input-dropdown-wrap interest-industry">
            <input
              type="text"
              className="s-input"
              className={classShowName}
              name="tag-keyword"
              placeholder="输入并选择领域"
              onChange={this.handleChange}
            />
            {
              this.state.showMask &&
              <div className="drop-list">
                {
                  this.state.tagNameList.map((tag) => {
                    return <div
                            className="drop-item"
                            key={tag}
                            onClick={ ()=> {
                              var _list = this.props.tags.map( (item) => {return item })
                              if (_list.indexOf(tag) > -1) {

                                this.setState({
                                  tagNameList: [] ,
                                  showMask: false
                                })
                                return
                              }
                              _list = [tag].concat(_list)

                              this.props.onValueChange({
                                tags: _list,
                              })
                              this.setState({
                                tagNameList: [],
                                showMask: false,
                              })
                            }}
                            >{tag}</div>
                  })
                }
              </div>
            }
            {this.state.showMask &&
              <div
                className="select-mask"
                onClick={()=>{
                  this.setState({
                    tagNameList: '',
                    showMask: false,
                  })
                }}
              ></div>
            }
          </div>
          <div className="add-new-btn"
            onClick={()=>{
              this.setState({
                showMask: false
              })
              var _index = [].concat(this.props.tags).indexOf(this.state.keyword)
              if (_index == -1 && this.state.keyword) {
                var _list = [this.state.keyword].concat(this.props.tags)
                this.props.onValueChange({
                  tags: _list
                })
              }
            }}
          > + 添加</div>
          <div className="tag-item-wrap">
            {
              this.props.tags&&
              this.props.tags.map((item)=>{
                return <span className="tag-item"
                        key={item}
                        onClick={()=>{
                          var _list = [].concat(this.props.tags)
                          var _index = _list.indexOf(item)
                          _list.splice(_index, 1)
                          this.props.onValueChange({
                            tags: _list
                          })
                        }}
                        >{item}</span>
              })
            }
          </div>
       </div>
        { showErr && <span className="err-tips">请选择关注领域</span> }
      </div>
    )
  }
}

// 团队介绍
class IntroTeam extends Component {
  static defaultProps = {
    team_intro: '',
    holder: '不填写完整无法进入电话沟通筛选环节'
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.team_intro;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-textarea ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">团队介绍：</label>
        <textarea
          className={classShowName}
          name="team_intro"
          value={this.props.team_intro}
          onChange={this.handleChange}
          placeholder={this.props.holder}
        />
        { showErr && <span className="err-tips narrow-err-tips">{this.props.holder}</span> }
      </div>
    )
  }
}

// 团队规模
class TeamScale extends Component {
  static defaultProps = {
    team_scale: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    const showErr = this.props.checkErr && !!!this.props.team_scale;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-select ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">团队规模：</label>
        <select className={classShowName} name="team_scale" value={this.props.team_scale} onChange={this.handleChange}>
          <option value="">请选择</option>
          <option value="50人以下">50人以下</option>
          <option value="50-200人">50-200人</option>
          <option value="200人以上">200人以上</option>
          <option value="500人以上">500人以上</option>
        </select>
        { showErr && <span className="err-tips">请选择团队规模</span> }
      </div>
    )
  }
}

// 是否需要融资
class NeedFinancing extends Component  {
  static defaultProps = {
    is_need: ''
    // financing_needs: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    const showErr = this.props.checkErr && !!!this.props.is_need;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-select ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">是否需要融资：</label>
        <select className={classShowName} name="is_need" value={this.props.is_need} onChange={this.handleChange}>
          <option value="">请选择</option>
          <option value="需要">需要</option>
          <option value="暂不需要">不需要</option>
        </select>
        { showErr && <span className="err-tips">请选择是否需要融资</span> }
      </div>
    )
  }
}

// 公司简介
class CompanyIntro extends Component {
  static defaultProps = {
    intro: ''
  }
  constructor() {
    super();
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.intro;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-textarea ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">公司简介：</label>
        <textarea
          className={classShowName}
          name="intro"
          value={this.props.intro}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写公司简介</span> }
      </div>
    )
  }
}

// 同行人数
class Peer extends Component {
  static defaultProps = {
    companion_count: ''
  }
  handleChange = (e) => {
    const [key, value ] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.companion_count;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`;
    return (
      <div className="info-item">
        <label className="s-label">同行人数：</label>
        <input
          type="text"
          className={classShowName}
          name="companion_count"
          value={this.props.companion_count}
          onChange={this.handleChange}
        />
        { showErr && <span className="err-tips">请填写同行人数</span> }
      </div>
    )
  }
}

// upload logo
class UploadLogo extends Component {
  static defaultProps = {
    title: '项目 Logo:',
    logo: '',
    showLogoErr: false,
    showLogoRight: false
  }
  constructor(props) {
    super(props);
    this.state = {...props};
  }
  handleChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({
        showLogoLoading: true,
        showLogoRight: false,
        showLogoErr: false
      })
      let formData = new FormData();
      formData.append('file', file);
      // 上传 Logo
      post('/fancube/apply/upload-file/', formData, {
        headers: {'Content-Type': 'multipart/form-data'},
        onUploadProgress: progressEvent => {
          const complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
        }
      }).then(res => {
        if (res.code === 200) {
          this.props.onValueChange({
            logo: res.data.url
          })
          this.setState({
            showLogoRight: true,
            url: res.data.url
          })
        } else {
          this.setState({
            showLogoErr: true
          })
        }
        this.setState({
          showLogoLoading: false
        })
      }).catch(error => {
        this.setState({
          showLogoErr: true,
          showLogoLoading: false,
          Logo_Timeout: error.code === 'ECONNABORTED' ? '文件过大，上传超时。' : false
        })
      })
    }
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.url;
    return (
      <div className="info-item">
        <label className="s-label file-button-position">{this.props.title}</label>
        {
          <div className="inline-block">
            { !this.state.url && <img style={{width: '90px'}} src="https://static-image.xfz.cn/imgholder.png"/> }
            { this.state.url && <img style={{width: '90px', height: '90px'}} src={this.state.url}/> }
            <a href="javascript:;" className="a-file" style={{marginTop: "30px", marginLeft: '20px'}}>
              点击上传
              <input
                ref="upload"
                accept="image/*"
                type="file"
                className="file-button"
                name="file"
                onChange={this.handleChange}
              />
            </a>
            { showErr && <span className="err-tips err-upload-logo" >请上传 Logo</span> }
            <Dialog isShow={this.state.showLogoLoading}>
              <div className="wrapper-content sure-change-phone">
                <div className="title">正在上传...</div>
              </div>
            </Dialog>
            { this.state.showLogoRight && <div className="right-tips">上传成功</div> }
            { this.state.showLogoErr && <div className="err-tips">{ this.state.Logo_Timeout || '上传失败, 请重新上传' }</div> }
            <div className="logo-upload-tips" >注：请上传尺寸为 300*300 、不大于 2M 、 JPG 文件格式图片。 </div>
          </div>
        }
      </div>
    )
  }
}

// upload bp file
class UploadBP extends Component {
  static defaultProps = {
    title: '资本对接:',
    bp: {
      id: '',
      name: ''
    },
    showBPErr: false,
    showBPRight: false,
    pcTips: <div> <p>选填，提交BP有机会获得资本对接机会</p> <p>BP文件名格式：姓名+项目名BP</p> </div>,
    mobileTips: '',

  }
  constructor(props) {
    super(props);
    this.state = {...props};
  }
  handleChange = (e) => {
    const file = e.target.files[0];
  
    if (file) {
      if (file.size > 1024*1024*400) {
        this.setState({
          showBPErr: true,
          showBPLoading: false,
          BP_Timeout: 'BP文件需 400M 以下，请缩减后重试'
        })
        return 
      }

      this.setState({
        showBPLoading: true,
        showBPRight: false,
        showBPErr: false
      })
      let formData = new FormData();
      formData.append('bp', file);
      // 上传bp
      post('/fancube/apply/bp/', formData, {
        headers: {'Content-Type': 'multipart/form-data'},
        onUploadProgress: progressEvent => {
          const complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
        }
      }).then(res => {
        if (res.code === 200) {
          this.props.onValueChange({
            bp: {
              id: res.data.bp_id,
              name: file.name
            }
          })
          this.setState({
            BPFileName: file.name,
            showBPRight: true
          })
        } else {
          this.setState({
            showBPErr: true,
          })
        }
        this.setState({
          showBPLoading: false
        })
      }).catch(error => {
        this.setState({
          showBPErr: true,
          showBPLoading: false,
          BP_Timeout: error.code === 'ECONNABORTED' ? '上传超时，请重试或更换小文件' : false
        })
      })
    }
  }
  render () {
    const showErr = this.props.checkErr && !!!this.props.bp.id;
    return (
      <div className="info-item">
        <label className="s-label file-button-position">{this.props.title}</label>
        {
          isPhone() ?
          // phone
          <div>
            {this.props.mobileTips || <p className="bp-tips">选填，发送BP到bp@xfz.cn有机会获得资本对接机会<span className="grey-tips">(邮件标题及BP文件命名格式“姓名+项目名”)</span></p> }
          </div> :
          // pc
          <div className="inline-block">
            {this.props.pcTips}
            { this.props.bp.name && 
              <div>当前BP: {this.props.bp.name}</div>
            }
            <br/>
            <a href="javascript:;" className="a-file">
              +上传BP
              <input
                ref="upload"
                accept=".pdf,.ppt,.pptx"
                type="file"
                className="file-button"
                name="bp"
                onChange={this.handleChange}
              />
            </a>
            <span className="margin-left-20">{ this.state.BPFileName }</span>
            <Dialog isShow={this.state.showBPLoading}>
              <div className="wrapper-content sure-change-phone">
                <div className="title">正在上传BP...</div>
              </div>
            </Dialog>
            { showErr && <span className="err-tips" >请上传BP <br/></span> }
            { this.state.showBPRight && <span className="right-tips">BP上传成功</span> }
            { this.state.showBPErr && <span className="err-tips">{ this.state.BP_Timeout || '上传BP失败, 请重新上传' }</span> }
          </div>
        }
      </div>
    )
  }
}

// 项目阶段
class ProjectStage extends Component {
  static defaultProps = {
    status: '已发布'
  }
  handleChange = (e) => {
    const [key, value] = [e.target.name, e.target.value];
    this.props.onValueChange({
      [key]: value
    })
  }
  render() {
    return (
      <div className="info-item">
        <label className="s-label">项目阶段：</label>
        {isPhone() && <br/>}
        <label className="s-radio">
          <input type="radio" value="已发布" checked={this.props.status === '已发布' ? true: false} onChange={this.handleChange}  name="status" />
          <span className="span-radio">已发布</span>
        </label>
        <label className="s-radio">
          <input type="radio" value="研发中" checked={this.props.status === '研发中' ? true: false} onChange={this.handleChange}  name="status" />
          <span className="span-radio">研发中</span>
        </label>
        <label className="s-radio">
          <input type="radio" value="概念阶段" checked={this.props.status === '概念阶段' ? true: false} onChange={this.handleChange}  name="status" />
          <span className="span-radio">概念阶段</span>
        </label>
      </div>
    )
  }
}

// 期望融资金额
class ExpectedFinancingAmount extends Component {
  static defaultProps = {
    financing_needs: '',
    title: '期望融资金额:',
    name: 'financing_stage',
    showEqualOther: true 
  }

  constructor(props) {
    super(props)
    var _amount = ''
    var _type = ''
    var _equal = true

    if (props.data) {
      _amount = props.data.split('万')[0]
      _type = props.data.indexOf('人民币') > -1 ? 'rmb' : 'dollar'
      _equal = props.data.indexOf('或等值其它币种') > -1 ? true : false
    }

    this.state = {
      equalOtherChecked: _equal,
      currency_amount: _amount || '',
      currency_type: _type || 'rmb',
    }
  }

  handleChange = (e) => {
    const target = e.target
    const _value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    const [key, value] = [target.name, _value];
    this.setState({
      [key] : value
    } , () => {
      var res = '';
      if (this.state.currency_amount) {
        res = res + this.state.currency_amount
        if (this.state.currency_type == 'rmb') {
          res = res + '万人民币'
        } else {
          res = res + '万美元'
        }
        if (this.props.showEqualOther && this.state.equalOtherChecked) {
          res = res + '或等值其它币种'
        }
      }
      this.props.onValueChange({
        'financing_needs': res
      })
    })
  }
  render() {
    const showErr = this.props.checkErr && !!!this.state.currency_amount;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-select ${err}`;
    var localStyle = {
      width: "80px"
    }
    return (
      <div className="info-item">
        <label className="s-label">{ this.props.title }</label>
        {isPhone() && <br/>}
        <input
          style = {this.props.showEqualOther ? {width: '54px'} : {width: '100px'}}
          type="number"
          className={classShowName}
          name="currency_amount"
          value={this.state.currency_amount}
          onChange={this.handleChange}
        />
        <span> 万 </span>
        <select
          className={classShowName}
          style = {this.props.showEqualOther ? {width: '80px'} : {width: '100px'}}
          name="currency_type"
          value={this.state.currency_type}
          onChange={this.handleChange}>
          <option value="rmb">人民币</option>
          <option value="dollar">美元</option>
        </select> &nbsp;
        { this.props.showEqualOther && 
          <span>
            <input type="checkbox"
              id="equal-other-currency"
              name="equalOtherChecked"
              checked={this.state.equalOtherChecked}
              onChange={this.handleChange}
            />
            <label htmlFor="equal-other-currency"> 或等值其它币种 </label>
          </span>
        }
        { showErr && <span className="err-tips">未填写需融资金额<br/></span> }
      </div>
    )
  }
}


// 历史融资
class SelectDate extends Component {
  static defaultProps = {
    title: '日期:',
    year: '',
    month: '',
  }
  constructor (props) {
    super(props);
    this.state = {...props}
    // console.log("--------year -date--->" + this.state.date)
    if (this.state.date) {
      var _date = this.state.date.split('-')
      this.state.year = _date[0]
      this.state.month = parseInt(_date[1])
    } else {
      this.state.year = new Date().getFullYear()
      this.state.month = 1
      this.fillDate()
    }

    this.yearList= []
    var currentYear = new Date().getFullYear();
    for(var i = currentYear; i > currentYear - 21; i-- ) {
      this.yearList.push(i);
    }
  }
  handleChange = (e) => {
    const target = e.target
    const [key, value] = [target.name, target.value];
    this.setState({
      [key] : value
    } , () => {
      this.fillDate()
    })
  }
  fillDate() {
    var res = '';
    var _month = this.state.month + ""
    res = this.state.year + '-' + _month.padStart(2,0)
    this.props.onValueChange({
      'date': res
    })
  }
  render() {
    return (
      <div className="info-item select-date">
        <label className="s-label">{ this.props.title }</label>
        <select className="select-year"
          name="year"
          value={this.state.year}
          onChange={this.handleChange}>
          {
            this.yearList.map(val => {
              return <option key={val.toString()} value={val}>{val}</option>
            })
          }
        </select>&nbsp; 年
        &nbsp;&nbsp;
        <select className="select-month"
          name="month"
          value={this.state.month}
          onChange={this.handleChange}>
          {
            [1,2,3,4,5,6,7,8,9,10,11,12].map(val => {
              return <option key={val.toString()} value={val}>{val}</option>
            })
          }
        </select>
        &nbsp;月
      </div>
    )
  }
}



// 项目标签
class OrgList extends Component {
  static defaultProps = {
    organList: []
  }
  constructor(props) {
    super(props)
    this.state = {
      ...props,
      tagNameList: [],
      showMask: false,
      keyword: ''
    }
  }
  handleChange = (e) => {
    if (e.target.name == 'tag-keyword') {
      this.getTagList(e.target.value)
    }
  }
  getTagList = (keyword) => {
    this.setState({
      tagNameList: [],
      showMask: true,
      keyword: keyword
    })

    get('/fancube/organ/outer/check/',{
      params:{'keyword': keyword}
    })
    .then( res => {
      this.setState({
        tagNameList: res.data.organs
      })
      if (res.data.organs.length == 0) {
        this.setState({
          showMask: false
        })
      }
    })
  }
  render() {
    const showErr = this.props.checkErr && [].concat(this.state.organList).length == 0;
    const err = showErr ? 'err-s' : '';
    const classShowName = `s-input ${err}`
    return (
      <div className="info-item">
        <label className="s-label">投资机构：</label>
        <div className="multiple-select-wrap">
          <div className="input-dropdown-wrap interest-industry">
            <input
              type="text"
              className="s-input"
              className={classShowName}
              name="tag-keyword"
              placeholder="输入并选择投资机构"
              onChange={this.handleChange}
            />
            {
              this.state.showMask &&
              <div className="drop-list">
                {
                  this.state.tagNameList.map((tag) => {
                    return <div
                            className="drop-item"
                            key={tag}
                            onClick={ ()=> {
                              var _list = this.props.organList.map( (item) => {return item })
                              if (_list.indexOf(tag) > -1) {
                                this.setState({
                                  tagNameList: [] ,
                                  showMask: false
                                })
                                return
                              }
                              _list = [tag].concat(_list)
                              this.props.onValueChange({
                                organList: _list,
                              })
                              this.setState({
                                tagNameList: [],
                                showMask: false,
                              })
                            }}
                            >{tag}</div>
                  })
                }
              </div>
            }
            {this.state.showMask &&
              <div
                className="select-mask"
                onClick={()=>{
                  this.setState({
                    tagNameList: '',
                    showMask: false,
                  })
                }}
              ></div>
            }
          </div>
          <div className="add-new-btn"
            onClick={()=>{
              this.setState({
                showMask: false
              })
              var _index = [].concat(this.state.organList).indexOf(this.state.keyword)
              if (_index == -1 && this.state.keyword) {
                var _list = [this.state.keyword].concat(this.props.organList)
                this.props.onValueChange({
                  organList: _list
                })
              }
            }}
          > + 添加</div>
          <div className="tag-item-wrap">
            {
              this.props.organList&&
              this.props.organList.map((item)=>{
                return <span className="tag-item"
                        key={item}
                        onClick={()=>{
                          var _list = [].concat(this.props.organList)
                          var _index = _list.indexOf(item)
                          _list.splice(_index, 1)
                          this.props.onValueChange({
                            organList: _list
                          })
                        }}
                        >{item}</span>
              })
            }
          </div>
       </div>
        { showErr && <span className="err-tips">请选择关注领域</span> }
      </div>
    )
  }
}
class FinancingHistoryList extends Component {
    static defaultProps = {
      dataList: [],
    } 
    constructor (props) {
      super(props);
      this.state = {...props}
      this.state.dataList = this.state.dataList.map( item => {
        return {...item,
          org: item.organ_list.map(_org => _org.organization__name).join(',')
        }
      })
    }
    editHistory = (his) => {
      this.props.onValueChange({data: his})
    }
    formatAmount = (amount,round) => {
      if ('尚未获投' == round) return '' 

      // console.log('amount' + JSON.stringify(amount))
      var res = ''
      if (amount && amount.indexOf('万') > -1 ) {
        var _int = amount.split('万')[0]
        _int = parseInt(_int)
        res = _int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +'万' +  amount.split('万')[1]
      }
      return res || amount || '金额不便透露'
    }
    render() {
      return (
        <div>
          { isPhone() ? 
            <div className="history-list">
              {
                this.state.dataList.map(val => {
                  return <div className="history-item" 
                            onClick={()=> this.editHistory(val)}
                            key={val.id}>
                            <div>
                              <div className="first-cell" style={{'font-weight': 'bold'}}> {val.round} </div>
                              <div className="middle-cell"> {this.formatAmount(val.amount, val.round)}  </div>
                              <div className="last-cell"> {val.date} </div>
                            </div>
                            <div className="org-line"> {val.org} </div>
                          </div>
                })
              }
            </div>
          :
            <table className="history-list">
              <tbody>
              {
                this.state.dataList.map(val => {
                  return <tr className="history-item" key={val.id}>
                            <td className="first-cell"> {val.round} </td>
                            <td> { this.formatAmount(val.amount, val.round) }</td>
                            <td> {val.org} </td>
                            <td className="last-cell"> {val.date} </td>
                            <td className="edit-btn" onClick={()=> this.editHistory(val)}> 修改 </td>
                          </tr>
                })
              }
              </tbody>
            </table>
          }
        </div>
      )
    }

}

// 历史融资
class EditFinancingHistory extends Component {
    static defaultProps = {
      ound: '',
    }
    constructor (props) {
      super(props);
      this.state = {...props}
      this.state.commitFlag = false
      this.state.organList = this.state.org ? this.state.org.split(',') : []
    }
    handleValueChange = (resObj) => {
      for(let index in resObj){
        if (typeof(resObj[index]) === 'string' ) {
          resObj[index] = resObj[index].replace(/^\s*/g,"");
        }

        if (index == 'financing_needs') {
          resObj.amount = resObj.financing_needs
        }
      }
      this.setState({
        ...resObj
      }, () => {
        // this.state.isRight = this.validateFunction();
        // this.props.receiveData(this.state);
      });
    }
    saveFinancingHistory = () => {
      var _noVC = this.state.round == '不便透露' || this.state.round == '尚未获投' ? true : false
      var _amount = _noVC || this.state.amount == '万人民币' || this.state.amount == '万美元'
      var _params = {
        ...this.state.idObj,
        round: this.state.round,
        date:  _noVC ? '' : this.state.date,
        amount:  _amount ? '' : this.state.amount,
        currency: this.state.currency,
        organ_name_list: this.state.organList
      }

      post('/fancube/apply/v2/history-financing/add/', _params).then(res => {
        if (this.state.commitFlag) return
        this.setState({ commitFlag: true })
        if (res.code === 200) {
          this.setState({ commitFlag: false })
          this.props.onRegetFinancingHistory(res.data.info)
        }
      })
    }
    updateFinancingHistory = () => {
      var _noVC = this.state.round == '不便透露' || this.state.round == '尚未获投' ? true : false
      // console.log("---update -date---" + this.state.date)
      var _params = {
        ...this.state.idObj,
        financing_id: this.state.id,
        round: this.state.round,
        date:  _noVC ? '' : this.state.date,
        amount: _noVC ? '' : this.state.amount,
        currency: this.state.currency,
        organ_name_list: this.state.organList
      }

      post('/fancube/apply/v2/history-financing/modify/', _params).then(res => {
        if (this.state.commitFlag) return
        this.setState({
          commitFlag: true
        })
        if (res.code === 200) {
          this.props.onRegetFinancingHistory()
          this.setState({
            commitFlag: false
          })
        }
      })
    }

    cancelEdit = () => { 
      this.props.onCancelEdit() 
      scrollToAnchor('history-financing')
    }
    render() {
      return (
        <div className="edit-history-financing">
          <div className="cancel-edit" 
            onClick={ this.cancelEdit }>×</div>
          <FinancingRound
            title={'融资轮次:'}
            name={'round'}
            style={{'width': '200px'}}
            type={'small'}
            financing_stage={this.state.round}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
          <ExpectedFinancingAmount
            title={'融资金额:'}
            data={this.state.amount}
            showEqualOther={false}
            onValueChange={this.handleValueChange}
          />
          <SelectDate
            date={this.state.date}
            title={'融资时间:'}
            onValueChange={this.handleValueChange}
          />
          <OrgList
            checkErr= {false}
            organList={this.state.organList}
            onValueChange={this.handleValueChange}
          />

          {this.state.id ?
            <div className="center-child">
              <div className={"submit-form inline-light-btn"}
                onClick={ ()=> {this.props.onDelete()} }>删除</div> &nbsp;&nbsp;
              <div className={"submit-form inline-colored-btn"}
                onClick={ this.updateFinancingHistory }>保存</div>
            </div>
          :
          <div className="center-child">
            <div className={"submit-form inline-colored-btn"}
              onClick={ this.saveFinancingHistory }>保存</div>
          </div>
          }
        </div>
      )
    }
}

// 投融资服务 fa
class ProjectInfoFa extends Component {
  static defaultProps = {
    status: '已发布'
  }
  constructor (props) {
    super(props);
    this.state = {
      ...props,
    };
    this.state.status = this.state.status ? this.state.status : '已发布';
    this.resetEditFinancingData()
    this.state.isEditFinancing = false
    this.isRight = true;
    // console.log("------ ProjectInfoFa ---->" + JSON.stringify(this.state))
  }
  resetEditFinancingData = () => {
    this.state.editFinancingData = {
          amount: "万人民币",
          currency: "人民币",
          date: "2020-01",
          id: 0,
          investor: "",
          organ_list: [],
          round: "尚未获投",
    }
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string' ) {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
      if (index === 'kryptis' && this.state.industry) {
        this.state.industry[0] = resObj[index] ;
      }
      if (index === 'laukas' && this.state.industry) {
        this.state.industry[1] = resObj[index];
      }
    }

    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  handleShowEditFinancingData = (data) => {
    scrollToAnchor('history-financing')
    this.setState({'isEditFinancing': true, editFinancingData: data.data})
  }
  validateFunction = () => {
    let flag = true;
    // let vList = ['name','brief','status','current_round', 'logo','financing_stage', 'intro', 'company_highlights','team_intro', 'financing_needs',];
    let vList = ['name','brief','status','intro','company_highlights','team_intro',];

    for (let i in this.state) {
      if (vList.indexOf(i) > -1 && !this.state[i]) {
        // console.log(" ****** check false ------>" + i)
        flag = false;
      }
      if (i == 'brief' && this.state.brief.length > 100) {
        flag = false;
      }
      if ((i == 'intro' || i == 'company_highlights' || i == 'team_intro') && this.state[i].length > 800) {
        flag = false;
      }
      if (!isPhone() && i == 'bp' && !this.state.bp.id) {
        flag = false ;
      }
    }
    return flag;
  }
  deleteFinancingItem = (id) => {
    var _params = {...this.state.idObj,financing_id: this.state.editFinancingData.id}
    post('/fancube/apply/v2/history-financing/delete/', _params).then(res => {
      if (res.code === 200) {
        this.getFinancingList()
      }
    })
  }
  cancelEdit = () => {
    this.setState({ 
      isEditFinancing: false,
    })
    this.resetEditFinancingData()
  }

  getFinancingList = (data) => {
    this.resetEditFinancingData()
    if (data) {
      this.state.idObj.en_id = data.en_id
      this.state.idObj.financing_id = data.financing_id
      this.state.idObj.project_id = data.project_id
      // this.props.updateProjectId(data.project_id)
    }
    var _params = {...this.state.idObj}
    post('/fancube/apply/v2/history-financing/', _params).then(res => {
      if (res.code === 200) {
        this.setState({ 
          isEditFinancing: false,
          history_financing_list: res.data.history_financing_list,
        })
      }
    })
  }

  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render () {
    const kryptisLaukas = {
      kryptis: this.state.industry && this.state.industry.length > 0 ? this.state.industry[0] : '',
      laukas: this.state.industry && this.state.industry.length > 1 ? this.state.industry[1] : ''
    }
    if (!this.state.industry) {
      this.state.industry = ['', ''];
    }
    var titleStyle = {
      marginTop: '30px',
      borderTop: '1px solid #ededed',
      padding: '20px 0',
    }
    return (
      <div className="project-info padding-top-30 padding-bottom-30">
        <p className="s-title">项目信息</p>

        {/* 公司名称 */
          false && 
          <Company
            company_name={this.state.company_name}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
        }

        {/* 公司架构 */ false && 
          <CompanyStructure
            company_structure={this.state.company_structure}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
        }

        { /* 公司行业领域 */ false && 
          <ProjectTag
            tags={this.state.tags}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
        }

        { false &&
          <KryptisLaukas
            recive_title="公司行业/领域:"
            {...kryptisLaukas}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
        }

        <ProjectName
          name={this.state.name}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />

        { false && 
          <UploadLogo
            url={this.state.logo}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
        }

        <CommonTextarea
          intro={this.state.brief}
          title = {"项目一句话介绍:"}
          holder = {"请填写项目一句话介绍 (100字以内)"}
          name = {"brief"}
          value= {this.state.brief}
          maxLength={100}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />

        {false &&
          <CommonInput
            title = {"你在项目中的角色:"}
            name = {"position"}
            value = {this.state.position}
            checkErr= {this.props.checkErr}
            errorMsg={"请填写角色"}
            onValueChange={this.handleValueChange}
          />
        }

        {/** 项目阶段 **/
          false &&
          <ProjectStage
            status = {this.state.status}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
        }
        { false &&
          <FinancingRound
            financing_stage={this.state.current_round}
            title={"目前融资轮次:"}
            name={"current_round"}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
        }

        <div className="s-title" style={titleStyle}> 项目介绍 </div>

        <CommonTextarea
          title = {"业务介绍:"}
          holder = {"请填写业务介绍 (800字以内)"}
          name = {"intro"}
          maxLength={800}
          value = {this.state.intro}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />

        <CommonTextarea
          title = {"公司亮点:"}
          holder = {"请填写公司亮点 (800字以内)"}
          name = {"company_highlights"}
          maxLength={800}
          value = {this.state.company_highlights}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />

        {false &&
          <CommonTextarea
            title = {"产品与商业模式:"}
            holder = {"请填写产品与商业模式"}
            name = {"pb_model"}
            value = {this.state.pb_model}
            onValueChange={this.handleValueChange}
          />
        }

        {false &&
          <CommonTextarea
            title = {"运营数据:"}
            holder = {"请填写运营数据"}
            name = {"operate_data"}
            value = {this.state.operate_data}
            onValueChange={this.handleValueChange}
          />
        }

        {false &&
          <CommonTextarea
            title = {"市场与竞争分析:"}
            holder = {"请填写市场与竞争分析"}
            name = {"mc_analysis"}
            value = {this.state.mc_analysis}
            onValueChange={this.handleValueChange}
          />
        }

        { false && 
          <div className="s-title" style={titleStyle}> 团队介绍 </div>
        }

        <CommonTextarea
            title = {"团队介绍:"}
            holder = {"请填写团队介绍 (800字以内)"}
            name = {"team_intro"}
            maxLength={800}
            value = {this.state.team_intro}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />

        <div>
          <div className="s-title" style={titleStyle}> 
            融资历史 
            <div className="inline-light-btn" 
              style={{width: '80px'}}
              onClick={ () => {
                this.setState({
                  isEditFinancing: true
                })
                scrollToAnchor('history-financing')
            }}>+ 添加</div>
          </div>
          <div id="history-financing"></div>
          { this.state.isEditFinancing ? 
            <EditFinancingHistory
              {...this.state.editFinancingData}
              idObj={this.props.idObj}
              onCancelEdit={this.cancelEdit}
              onDelete={this.deleteFinancingItem }
              onRegetFinancingHistory={this.getFinancingList}
            />
            :
            <FinancingHistoryList
              dataList={this.state.history_financing_list}
              onValueChange={this.handleShowEditFinancingData}
            />
          }
          <div className="s-title" style={titleStyle}> 融资需求 </div>
          <FinancingRound
            title={"需要融资轮次:"}
            name={"financing_stage"}
            type={'smallest'}
            financing_stage={this.state.financing_stage}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
          <ExpectedFinancingAmount
            data={this.state.financing_needs}
            showEqualOther={false}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
        </div>

        <UploadBP
          title={"上传 BP:"}
          bp={this.state.bp}
          pcTips={ <div> <p> BP信息仅小饭桌工作人员可见，会为你保密！</p><p>BP文件需 10M 以下，PDF 格式文件</p> </div>}
          mobileTips={ <div> 因移动端限制无法上传BP，可提交后使用电脑端补充上传或添加工作人员微信（13810700473），备注“姓名-BP”提交BP。</div>}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
      </div>
    )
  }
}

// class 线下课堂报名表组件
class ProjectInfoClass extends Component {
  static defaultProps = {
    status: '创业中'
  }
  constructor (props) {
    super(props);
    this.state = {...props};
    this.isRight = true;
    if (this.state.classType == '创新成长学院') {
      this.state.status = '在职'
    } else {
      this.state.status = this.state.status ? this.state.status : '创业中'
    }
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string' ) {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
      if (index === 'kryptis' && this.state.industry) {
        this.state.industry[0] = resObj[index] ;
      }
      if (index === 'laukas' && this.state.industry) {
        this.state.industry[1] = resObj[index];
      }
    }
    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    let projectVliArr = ['status', 'name', 'industry', 'position'];

    if (this.state.status === '准备创业') {
      projectVliArr = projectVliArr.concat(['intro'])
    } else if (this.state.status === '创业中') {
      if (this.state.classType == '卓见沙龙') {
        // 
      } else {
        projectVliArr = projectVliArr.concat(['intro', 'team_intro', 'financing_stage','financing_needs'])
      }
    } else if (this.state.status === '在职') {
      if (this.state.classType == '创新成长学院') {
        // projectVliArr = projectVliArr.concat(['history_shareholder','intro','entre_intro','team_intro','financing_stage','financing_needs'])
        projectVliArr = ['name','status','position','history_shareholder','intro','entre_intro','team_intro','financing_stage','financing_needs']
      }
    }

    validateMap.set('classValidate', projectVliArr);

    for (let i in this.state) {
      if (validateMap.get('classValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
      }
      // 处理数组校验
      if (i === 'industry' && validateMap.get('classValidate').indexOf(i) > -1 && (!this.state[i][0] || !this.state[i][1])) {
        flag = false;
      }
    }
    return flag;
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render () {
    const kryptisLaukas = {
      kryptis: this.state.industry && this.state.industry.length > 0 ? this.state.industry[0] : '',
      laukas: this.state.industry && this.state.industry.length > 1 ? this.state.industry[1] : ''
    }
    if (!this.state.industry) {
      this.state.industry = ['', ''];
    }
    return (
      <div className="project-info padding-top-30 padding-bottom-30">
        <p className="s-title">{this.state.userRole=='onTheJob'?'公司信息':'项目信息'}</p>
        {/* 特殊情况下 不显示状态选择 默认是创业中 */}
        {/* <h2>{this.state.classType}</h2> */}
        {/* 卓见沙龙 */}
        {
          this.state.classType == '卓见沙龙' &&
          <div>
          {
            this.state.status === '创业中' &&
            <div className="only-status-in">
              <Position
                position={this.state.position}
                checkErr= {this.props.checkErr}
                onValueChange={this.handleValueChange}
              />
              <ProjectName
                name={this.state.name}
                recive_title={this.state.userRole == 'onTheJob' ? '公司名称:' : '项目名称:'}
                checkErr= {this.props.checkErr}
                classType={this.state.classType}
                onValueChange={this.handleValueChange}
              />
              <KryptisLaukas
                {...kryptisLaukas}
                recive_title={this.state.userRole == 'onTheJob' ? '公司行业/领域:' : '项目行业/领域'}
                checkErr= {this.props.checkErr}
                onValueChange={this.handleValueChange}
              />
              {this.state.userRole != 'onTheJob' &&
                <div>
                  <FinancingRound
                    financing_stage={this.state.financing_stage}
                    checkErr= {this.props.checkErr}
                    onValueChange={this.handleValueChange}
                  />
                  <IntroProject
                    intro={this.state.intro}
                    classType={this.state.classType}
                    userRole={this.state.userRole}
                    checkErr= {this.props.checkErr}
                    onValueChange={this.handleValueChange}
                  />
                  <NeedFinancing
                    is_need={this.state.is_need}
                    checkErr= {this.props.checkErr}
                    onValueChange={this.handleValueChange}
                  />
                </div>
              }
              {/* 特殊情况下 不显示BP */}
              {
                !this.props.special_nostausbp &&  this.state.userRole != 'onTheJob'&&
                <UploadBP
                  onValueChange={this.handleValueChange}
                />
              }
            </div>
          }
          {
            this.state.status === '在职' &&
            <div className="only-status-in">
              <ProjectName
                recive_title="公司名称:"
                name={this.state.name}
                checkErr= {this.props.checkErr}
                onValueChange={this.handleValueChange}
              />
              <KryptisLaukas
                recive_title="公司行业/领域:"
                {...kryptisLaukas}
                checkErr= {this.props.checkErr}
                onValueChange={this.handleValueChange}
              />
              <Position
                position={this.state.position}
                checkErr= {this.props.checkErr}
                onValueChange={this.handleValueChange}
              />
            </div>
          }
          </div>
        }

        {/* 创新成长学院 */}
        {
          this.state.classType == '创新成长学院' &&
          <div>
            {
              this.state.status === '在职' &&
              <div className="only-status-in">
                <ProjectName
                  name={this.state.name}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <Position
                  position={this.state.position}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <FinancingRound
                  title = {"目前融资轮次:"}
                  type = {"type4"}
                  financing_stage={this.state.financing_stage}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                {/* todo 历史股东 */}
                <CommonTextarea
                  title = {"历史股东:"}
                  holder = {"请填写融资轮次与投资机构"}
                  name = {"history_shareholder"}
                  maxLength={800}
                  value = {this.state.history_shareholder}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <CommonTextarea
                  title = {"项目介绍:"}
                  holder = {"请填写项目介绍信息及核心竞争力等，不少于100字"}
                  name = {"intro"}
                  maxLength={800}
                  value = {this.state.intro}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                {/* todo 个人介绍[后端] */}
                <CommonTextarea
                  title = {"个人介绍:"}
                  holder = {"个人过往经历及背景，不少于100字"}
                  name = {"entre_intro"}
                  maxLength={800}
                  value = {this.state.entre_intro}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <IntroTeam
                  team_intro={this.state.team_intro}
                  holder={"核心创始团队介绍，不少于100字"}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <TeamScale
                  team_scale={this.state.team_scale}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                {/* <NeedFinancing
                  is_need={this.state.is_need}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                /> */}

                {/* 特殊情况下 不显示BP */}
                {
                  !this.props.special_nostausbp && !isPhone() && 
                  <UploadBP
                    title={"上传BP:"}
                    pcTips= {<div> <p>PPT、PDF格式均可</p> <p>文件命名：姓名+项目名</p> </div>}
                    onValueChange={this.handleValueChange}
                  />
                }

                {
                  !this.props.special_nostausbp && isPhone() &&
                  <UploadBP
                    title={"项目BP:"}
                    mobileTips={<p className="bp-tips">发送BP到bp@xfz.cn<span className="grey-tips">(PPT、PDF格式均可，文件命名：姓名+项目名)</span></p> }
                    onValueChange={this.handleValueChange}
                  />
                }
              </div>
            }
          </div>
        }

        {/* 非 卓见沙龙 和 非 创新成长学院 */}
        {
          this.state.classType != '卓见沙龙' && this.state.classType != '创新成长学院' &&
          <div>
            {
              !this.props.special_nostausbp &&
              <WorkStatus
                status={this.state.status}
                onValueChange={this.handleValueChange}
              />
            }

            {
              this.state.status === '创业中' &&
              <div className="only-status-in">
                <Position
                  position={this.state.position}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <ProjectName
                  name={this.state.name}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <KryptisLaukas
                  {...kryptisLaukas}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <FinancingRound
                  financing_stage={this.state.financing_stage}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <IntroProject
                  intro={this.state.intro}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <IntroTeam
                  team_intro={this.state.team_intro}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <NeedFinancing
                  is_need={this.state.is_need}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                {/* 特殊情况下 不显示BP */}
                {
                  !this.props.special_nostausbp &&
                  <UploadBP
                    onValueChange={this.handleValueChange}
                  />
                }
              </div>
            }

            {
              this.state.status === '准备创业' &&
              <div className="only-status-in">
                <Position
                  position={this.state.position}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <ProjectName
                  name={this.state.name}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <KryptisLaukas
                  {...kryptisLaukas}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <IntroProject
                  intro={this.state.intro}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
              </div>
            }

            {
              this.state.status === '在职' &&
              <div className="only-status-in">
                <ProjectName
                  recive_title="公司名称:"
                  name={this.state.name}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <KryptisLaukas
                  recive_title="公司行业/领域:"
                  {...kryptisLaukas}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
                <Position
                  position={this.state.position}
                  checkErr= {this.props.checkErr}
                  onValueChange={this.handleValueChange}
                />
              </div>
            }
          </div>
        }

      </div>
    )
  }
}

// class 线下课堂报名表组件 (媒体)
class ProjectInfoMedia extends Component {
  constructor (props) {
    super(props);
    this.state = {...props};
    this.isRight = true;
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string' ) {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
      if (index === 'kryptis') {
        this.state.industry[0] = resObj[index];
      }
      if (index === 'laukas') {
        this.state.industry[1] = resObj[index];
      }
    }
    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    let projectVliArr = ['name', 'intro', 'industry', 'brief', 'financing_needs', 'financing_stage'];
    validateMap.set('mediaValidate', projectVliArr);

    for (let i in this.state) {
      if (validateMap.get('mediaValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
      }
      // 处理数组校验
      if (i === 'industry' && validateMap.get('mediaValidate').indexOf(i) > -1 && (!this.state[i][0] || !this.state[i][1])) {
        flag = false;
      }
    }
    return flag;
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render () {
    const kryptisLaukas = {
      kryptis: this.state.industry && this.state.industry.length > 0 ? this.state.industry[0] : '',
      laukas: this.state.industry && this.state.industry.length > 1 ? this.state.industry[1] : ''
    }
    return (
      <div className="project-info padding-top-30 padding-bottom-30 border-bottom">
        <p className="s-title">项目信息</p>
        <ProjectName
          name={this.state.name}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <KryptisLaukas
          {...kryptisLaukas}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Brief
          brief={this.state.brief}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <IntroOtherProject
          intro={this.state.intro}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <FinancingRound
          financing_stage={this.state.financing_stage}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <NeedFinancing
          is_need={this.state.is_need}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
      </div>
    )
  }
}

// 城市合伙人报名表
class ProjectCityPartner extends Component {
  constructor (props) {
    super(props);
    this.state = {...props};
    this.isRight = true;
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string' ) {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
      if (index === 'kryptis') {
        this.state.industry[0] = resObj[index];
      }
      if (index === 'laukas') {
        this.state.industry[1] = resObj[index];
      }
    }
    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    let projectVliArr = ['name', 'intro', 'industry', 'position'];

    validateMap.set('cityValidate', projectVliArr);

    for (let i in this.state) {
      if (validateMap.get('cityValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
      }
      // 处理数组校验
      if (i === 'industry' && validateMap.get('cityValidate').indexOf(i) > -1 && (!this.state[i][0] || !this.state[i][1])) {
        flag = false;
      }
    }
    return flag;
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render() {
    const kryptisLaukas = {
      kryptis: this.state.industry && this.state.industry.length > 0 ? this.state.industry[0] : '',
      laukas: this.state.industry && this.state.industry.length > 1 ? this.state.industry[1] : ''
    }
    return (
      <div className="project-info padding-top-30 padding-bottom-30">
        <p className="s-title">项目信息</p>
        <ProjectName
          name={this.state.name}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <KryptisLaukas
          {...kryptisLaukas}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Position
          position={this.state.position}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <IntroProject
          intro={this.state.intro}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
      </div>

    )
  }
}

// 大会报名表
class ProjectCon extends Component {
  constructor (props) {
    super(props);
    this.state = {...props};
    this.isRight = true;
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string' ) {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
    }
    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    let projectVliArr = ['company_name', 'intro', 'position'];

    validateMap.set('conValidate', projectVliArr);

    for (let i in this.state) {
      if (validateMap.get('conValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
      }
    }
    return flag;
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render() {
    return (
      <div className="project-info padding-bottom-30">
        <Company
          company_name={this.state.company_name}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <Position
          position={this.state.position}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        <IntroProject
          intro={this.state.intro}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
      </div>

    )
  }
}

// 游学 线下课堂报名表组件
class ProjectInfoExpo extends Component {
  static defaultProps = {
    companion_count: ''
  }
  constructor (props) {
    super(props);
    this.state = {...props};
    this.isRight = true;
  }
  handleValueChange = (resObj) => {
    for(let index in resObj){
      if (typeof(resObj[index]) === 'string' ) {
        resObj[index] = resObj[index].replace(/^\s*/g,"");
      }
    }
    this.setState({
      ...resObj
    }, () => {
      this.state.isRight = this.validateFunction();
      this.props.receiveData(this.state);
    });
  }
  validateFunction = () => {
    let flag = true;
    const validateMap = new Map();
    let projectVliArr = ['name', 'companion_count', 'intro'];
    if (this.props.isCustom) {
      projectVliArr = ['name', 'intro'];
    }

    validateMap.set('expoValidate', projectVliArr);
    for (let i in this.state) {
      if (validateMap.get('expoValidate').indexOf(i) > -1 && !this.state[i]) {
        flag = false;
        break;
      }
    }
    return flag;
  }
  componentDidMount () {
    this.state.isRight = this.validateFunction();
    this.props.receiveData(this.state);
  }
  render () {
    return (
      <div className="project-info">
        <ProjectName
          name={this.state.name}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
        {
          !this.props.isCustom &&
          <Peer
            companion_count={this.state.companion_count}
            checkErr= {this.props.checkErr}
            onValueChange={this.handleValueChange}
          />
        }
        <CompanyIntro
          intro={this.state.intro}
          checkErr= {this.props.checkErr}
          onValueChange={this.handleValueChange}
        />
      </div>
    )
  }
}


export {
  ProjectInfoFa,
  ProjectInfoClass,
  ProjectInfoExpo,
  ProjectCityPartner,
  ProjectCon,
  ProjectInfoMedia,
  UploadBP,
}
